import { render, staticRenderFns } from "./TraxUiAjaxStructTableWithActions.vue?vue&type=template&id=37c46cd8"
import script from "./TraxUiAjaxStructTableWithActions.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxStructTableWithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports